export const formatNumber = (value: number, precision: number) =>
  precision < 0 || precision > 100
    ? value.toString()
    : value.toFixed(precision);
